import * as React from 'react';

import {IconButton, withStyles, WithStyles} from '@material-ui/core';
import ArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft';
import ArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import {addDays} from '@helpers/DateHelper';
import {generateDays} from '@helpers/calendar/Generator';
import {generateAdjustScheule, ICustodyData, weeksNeeded} from './CalendarCalc';
import TranslateNew from '@translate/TranslateNew';

import { IHoliday } from '@constants/holidays/holidayTypes';
import { GuideComponentStyles } from './guidecomponent.styles';
import { primaryColor, secondaryColor } from 'src/main.style';

const tn: TranslateNew = TranslateNew.getInstance();


interface IAdjustDaysCalendarProps extends WithStyles<typeof GuideComponentStyles> {
  holidays: {[date: string]: IHoliday} ;
  schedule: boolean[];
  startDate: Date;
  endDate: Date;
  otherParent: string;
  myName: string;
  extraWidth?: number;
  localization: 'en'|'se';
}

interface IAdjustDaysCalendarState {
  displayMonth: Date;
  dayNames: any[];
  custody: ICustodyData[];
}

class AdjustDaysCalendar extends React.Component<IAdjustDaysCalendarProps, IAdjustDaysCalendarState> {

  constructor(props: IAdjustDaysCalendarProps) {
    super(props);
    const now: Date = addDays(props.startDate, 15);
    const dayNames = generateDays(now.getFullYear(), now.getMonth(), weeksNeeded(now.getFullYear(), now.getMonth(), this.props.localization),
      props.holidays, props.localization);

    const custody = generateAdjustScheule(dayNames[0].dateObject, props.startDate,
      dayNames[dayNames.length - 1].dateObject, props.endDate,
      props.schedule, this.props.localization);

    this.state = {
      custody,
      displayMonth: now,
      dayNames,
    };
  }

  public componentDidUpdate = (prevprops: IAdjustDaysCalendarProps) => {
    if (prevprops === this.props) {
      return;
    }

    const now = this.state.displayMonth;
    const dayNames = generateDays(now.getFullYear(), now.getMonth(),
      weeksNeeded(now.getFullYear(), now.getMonth(), this.props.localization), this.props.holidays, this.props.localization);
    const custody = generateAdjustScheule(dayNames[0].dateObject, this.props.startDate,
      dayNames[dayNames.length - 1].dateObject, this.props.endDate,
      this.props.schedule, this.props.localization);
    this.setState({custody, dayNames});
  }

  public render() {

    const weeks: any[] = [];

    for (let d = 0; d < this.state.dayNames.length; d += 7) {
      weeks.push(
        <div className={this.props.classes.row} key={d + 1}>
          {this.renderDay(d + 0,d>this.state.dayNames.length-8)}
          {this.renderDay(d + 1,d>this.state.dayNames.length-8)}
          {this.renderDay(d + 2,d>this.state.dayNames.length-8)}
          {this.renderDay(d + 3,d>this.state.dayNames.length-8)}
          {this.renderDay(d + 4,d>this.state.dayNames.length-8)}
          {this.renderDay(d + 5,d>this.state.dayNames.length-8)}
          {this.renderDay(d + 6,d>this.state.dayNames.length-8)}
        </div>
      );
    }

    return (
      <div className={this.props.classes.newcalendar} style={this.props.extraWidth
        ?{width:'calc(100% + '+this.props.extraWidth+'px)', marginLeft:(this.props.extraWidth*-0.5)}:{}}>
        <div className={this.props.classes.title}>
          <IconButton onClick={() => this.adjustMonth(false)}>
            <ArrowLeftIcon className={this.props.classes.whiteIcon}/>
          </IconButton>
          <div>
            {tn.lang.getMonthName(this.state.displayMonth.getMonth())
              + " " + this.state.displayMonth.getFullYear()}
          </div>
          <IconButton onClick={() => this.adjustMonth(true)}>
            <ArrowRightIcon className={this.props.classes.whiteIcon}/>
          </IconButton>
        </div>
        <div className={this.props.classes.row} key="0">
          {this.props.localization === "en" && <div className={this.props.classes.dayName} key="7">{tn.lang.sun}</div>} 
          <div className={this.props.classes.dayName} key="1">{tn.lang.mon}</div>
          <div className={this.props.classes.dayName} key="2">{tn.lang.tue}</div>
          <div className={this.props.classes.dayName} key="3">{tn.lang.wed}</div>
          <div className={this.props.classes.dayName} key="4">{tn.lang.thu}</div>
          <div className={this.props.classes.dayName} key="5">{tn.lang.fri}</div>
          <div className={this.props.classes.dayName}key="6">{tn.lang.sat}</div>
          {this.props.localization === "se" && <div className={this.props.classes.dayName} key="7">{tn.lang.sun}</div>}
        </div>
        {weeks}
      </div>
    );
  }

  private renderDay = (dayNumber: number, lastWeek:boolean) => {

    const firstDayOfWeek: boolean = (dayNumber % 7 === 0)

    return (
      <div className={this.props.classes.day} key={dayNumber}>
        <div className={this.props.classes.custody+" "+this.props.classes.borderBox+" "+this.props.classes.text 
          + (firstDayOfWeek ? (" "+this.props.classes.firstDayOfweek) : "")
          + (lastWeek ? (" "+this.props.classes.lastWeekOfMonth): "")}
          
          style={{backgroundColor: ((this.state.dayNames[dayNumber].dayType === "sunday"
            || this.state.dayNames[dayNumber].dayType === "saturday" || this.state.dayNames[dayNumber].dayType === "vacation")
              ?"#dddddd":"#eeeeee")}}
          >
          {this.state.dayNames[dayNumber].display}
        </div>
        {this.renderCustodyBar(dayNumber)}
      </div>
    );
  }

  private renderCustodyBar = (dayNumber: number) => {
    if (dayNumber >= this.state.custody.length) {
      return null;
    }
    const custody: ICustodyData = this.state.custody[dayNumber];

    const morningStyle:React.CSSProperties = {
      backgroundColor: custody.morningWithMe === undefined 
        ? "#00000000"
        : custody.morningWithMe === true ? primaryColor : secondaryColor,
      borderRadius: custody.morningWithMe ===  custody.eveningWithMe ? '0px':'0px 5px 5px 0px',
    };
    const nightStyle:React.CSSProperties = {
      left: '50%',
      backgroundColor: custody.eveningWithMe === undefined 
        ? "#00000000"
        : custody.eveningWithMe === true ? primaryColor : secondaryColor,
      borderRadius: custody.morningWithMe ===  custody.eveningWithMe ? '0px':'5px 0px 0px 5px',
    }; 
    let name:JSX.Element|undefined;
    if (custody.showName) {
      name = (<div className={this.props.classes.custodyName}>
        {custody.eveningWithMe?this.props.myName:this.props.otherParent}
        </div>);
    }
    return (<><div className={this.props.classes.custody} style={morningStyle}/>
    <div className={this.props.classes.custody} style={nightStyle}/>{name}</>);
  }

  private adjustMonth = (up: boolean) => {
    const newMonth = new Date(this.state.displayMonth);
    newMonth.setMonth(newMonth.getMonth() + (up ? 1 : -1));
    const dayNames = generateDays(newMonth.getFullYear(), newMonth.getMonth(),
      weeksNeeded(newMonth.getFullYear(), newMonth.getMonth(), this.props.localization),
      this.props.holidays, this.props.localization);
    const custody: any = generateAdjustScheule(dayNames[0].dateObject, this.props.startDate,
      dayNames[dayNames.length - 1].dateObject, this.props.endDate,
      this.props.schedule, this.props.localization);

    this.setState({dayNames, displayMonth: newMonth, custody});
  }
}
export default withStyles(GuideComponentStyles)(AdjustDaysCalendar);



// WEBPACK FOOTER //
// ./src/components/guide/components/AdjustDaysCalendar.tsx